import {
  Link,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/entmotivacional";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllEntmotivacionalByTax(params.tratamientoId);
}

export function EntmotivacionalList(props) {
  const [entmotivacionalList, setEntmotivacional] = useState([]);
  let { tratamientoId } = useParams();
  let lastItem;
  

  useEffect(() => {
    API.getAllEntmotivacionalByTax(props.id).then(setEntmotivacional).catch(console.log);
  }, [props.id]);

  if (entmotivacionalList) {
    lastItem = Object.values(entmotivacionalList).pop();
  }

  return (
    <>
      {lastItem ? (
            <NavLink key={lastItem.id} to={`${props.id}/antecedentes/entrevista-motivacional/${lastItem.id}`}>Entrevista Motivacional</NavLink>
          ) : (
            <NavLink to={`${props.id}/antecedentes/entrevista-motivacional/new`}>Entrevista Motivacional</NavLink>
          )}
    </>
  );
}


export function EntmotivacionalListContent(props) {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>Entrevista Motivacional</h1>
      </div>
      <div id="actions">
      {(props.userRole.includes('administrador') || props.userRole.includes('psicologia-hospital')) && (
        <Link className="button is-link" to={`new`}>Nuevo</Link>
      )}
      </div>
    </>
  );
}